import React from 'react'

export default function DesignPortfolio() {

    return(
        <div className="content-box">
            <h1>This page is under construction for now.</h1>
         </div>
    )
}